<template>
  <Patch>
    <h5 slot="title">紀錄報表</h5>

  </Patch>
</template>

<script>
import Patch from '../common/AdminPatch';

export default {
  name: 'ADCManagement',
  components: {
    Patch,
  },
};
</script>



// WEBPACK FOOTER //
// ReportExport.vue?33876808